// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".move-from-down[data-v-8bbc0ed8]{animation-duration:.35s;animation-name:mode-from-down-data-v-8bbc0ed8}@keyframes mode-from-down-data-v-8bbc0ed8{0%{transition-delay:300;transform:translateY(100%)}to{transform:translateY(0)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
